<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card flat style="border-radius: 15px" class="pa-4">
      <v-card-title> </v-card-title>
      <v-card-text class="text-center black--text my-2" style="font-size: 11pt">
        <v-img
          contain
          lazy-src="https://cdn.siap.id/s3/masook/asset%20img/SIM/danger.png"
          max-height="250"
          src="https://cdn.siap.id/s3/masook/asset%20img/SIM/danger.png"
        ></v-img>
        <div class="font-weight-bold headline my-3">Perhatian!</div>
        <template>
          Instansi Anda mengindikasikan belum ada pengaturan jam kerja yang diset sebagai default. Pastikan sudah ada
          jam kerja yang diset sebagai default terlebih dahulu
        </template>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" class="mr-2" style="border-radius: 5pt" @click="dialog = false">Tutup</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    open() {
      this.dialog = true
    },

    onClose() {
      this.dialog = false
    },
  },
}
</script>
